export enum EinreichungStep {
  INIT = 0,
  MAIN = 10,
  UPLOADING = 20,
  COMPLETE = 30,
}
